module.exports = __webpack_public_path__ + "img/4.9349ba30.jpeg";